// Lightweight auth helpers: decode JWT from localStorage and check roles

function getToken() {
  try {
    return localStorage.getItem('token') || '';
  } catch {
    return '';
  }
}

export function getTokenPayload() {
  const token = getToken();
  if (!token || token.split('.').length < 2) return null;
  const base64 = token.split('.')[1];
  try {
    const json = atob(base64.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    try {
      const json = atob(base64);
      return JSON.parse(json);
    } catch {
      return null;
    }
  }
}

export function extractRoles(payload) {
  if (!payload || typeof payload !== 'object') return [];
  // Common claim keys that may contain roles/authorities
  const candidates = [
    'roles',
    'authorities',
    'scopes',
    'scope',
    'permissions',
    'role'
  ];
  for (const key of candidates) {
    const value = payload[key];
    if (!value) continue;
    if (Array.isArray(value)) return value.map(String);
    if (typeof value === 'string') {
      // space or comma separated
      return value.split(/[ ,]+/).filter(Boolean).map(String);
    }
  }
  return [];
}

export function hasRole(role) {
  const payload = getTokenPayload();
  const roles = extractRoles(payload).map(r => r.toUpperCase());
  return roles.includes(String(role).toUpperCase());
}

export function isMarketingUser() {
  return hasRole('MARKETING');
}


